import { FlutterServiceError } from '../errors';
import { isFlutterVersionMin } from '@/utils/versions';
import { isIOS } from "@/utils/device/is-ios";

/**
 *
 * @param {object} serviceName
 * @param {object} payload
 * @return {void}
 */
 export const invokeFlutterService = (serviceName, payload = "") => {
    if (typeof window[serviceName] === 'undefined') {
        console.warn('Undefined service ' + serviceName);
        return invokeFallbackFlutterService(serviceName, payload);
    }
    else if (typeof window[serviceName].postMessage !== 'function') {
        console.warn('PostMessage unavailable for service ' + serviceName);
        return invokeFallbackFlutterService(serviceName, payload);
    }
    try {
        window[serviceName].postMessage(payload);
        return true;
    } catch (error) {
        console.error('PostMessage failed for service ' + serviceName);
        captureException(error);
        return false;
    }
}

/**
 * When the primary method fails (channel not available on device),
 * invoke fallback method exploiting navigationDelegate.
 * @param {*} serviceName
 * @param {*} payload
 */
const invokeFallbackFlutterService = (serviceName, payload) => {
    try {
        // @TODO: implement to iOS version
        if (isIOS()) {
            captureException(new FlutterServiceError('Call to service failed'));
            return false;
        }

        // Check minimum flutter version on android
        if (!isFlutterVersionMin('3.8.20')) {
            console.warn('Flutter version is too low to invoke fallback service');
            captureException(new FlutterServiceError('Call to service failed'));
            return false;
        }

        const messageUrl = 'https://flutter.app.denticalc.com/?data=';
        const data = {
            name: serviceName,
            message: typeof payload === 'string' ? payload : JSON.stringify(payload),
        }

        captureException(new FlutterServiceError('Fallback invoked for service ' + serviceName));

        location.replace(messageUrl + btoa(JSON.stringify(data)));
        return true;
    } catch (error) {
        console.error('Error calling fallback for service' + serviceName);
        captureException(error);
        return false;
    }
}
